module.exports = __webpack_public_path__ + "static/img/img-nav1.13bed51f.png";